/** A ReturnUrl is only followed when it is a path of this site (Url.IsLocalUrl). */
export function isLocalUrl(url: string | null | undefined): url is string {
  return !!url && url.startsWith('/') && !url.startsWith('//') && !url.startsWith('/\\');
}
